import { createContext, useContext } from 'react';

// What this deployment serves, as App read it once per session from GET /api/v0/capabilities.
// characterStub says whether the development panel — and the controls that only exist beside
// it — are served here. False until the answer arrives and false if it never does, so a screen
// consuming this never shows a development control to a student by accident.
export const CapabilitiesContext = createContext({ characterStub: false });

export function useCapabilities() {
  return useContext(CapabilitiesContext);
}
